import React from 'react';
import {connect} from 'react-redux';
import {loadLanguage} from 'Utils/jwtUtil';
// Components
import Header from 'Components/common/Header';
import ProductImage from 'Components/commonOrder/ProductImage';
import Anchor from 'Components/common/Anchor';
import CommonDialogWrapper from 'Components/replenishment/CommonShippingDetails';
import PackageDetailsDialog from 'Components/host/PackageDetailsDialog';
import SearchInput from 'Components/common/SearchInput';
import LoadingIcon from 'Components/icons/LoadingIcon';

// Actions
import {openNotification} from 'Actions/notification';
import {
    getF1OrderDetails,
    productsReceive,
    getAllSkuConditionList,
    updateF1OrderReceiveSearchList,
    updateF1OrderReceiveOrder,
} from 'Actions/host';
import {T} from 'Actions/translate';
import {getSkuReplenishmentDetails} from 'Actions/host';

class F1OrderDetailPage extends React.Component {
    state = {
        productsReceivingQuantity: [],
        receiveBtnsIsLoading: [],
        receiveAllBtnIsLoading: false,
        exitOpened: false,
        receiveExitOpened: false,
        f1OrderReceiveData: [],
        isAllReceive: false,
        productQuantity: [],
        currentItem: null,
        currentIndex: 0,
        checked: true,
        defaultCheck: null,
        checkAll: true,
        currentProductIds: [],
        allReceiveOrderArry: [],
        f1OrderReceiveList: [],
        f1OrderDetailPageLoad: true,
    };

    componentWillMount() {
        this.props.updateF1OrderReceiveSearchList({
            queryKey: {$set: ''},
        });

        this.getOrderDetails();
    }

    search = () => {
        this.setState({f1OrderReceiveList: []});
        this.getOrderDetails(this.props.queryKey);
    };

    getOrderDetails = (queryKey) => {
        let paramsObj = '';
        if (typeof queryKey !== 'undefined' && queryKey) {
            paramsObj = {
                id: this.props.match.params.id,
                queryKey: this.props.queryKey,
            };
        } else {
            paramsObj = this.props.match.params;
        }

        this.props.getF1OrderDetails(paramsObj).then((res) => {
            let productsReceivingQuantity = [];
            let receiveBtnsIsLoading = [];
            let allF1OrderReceiveList = [];

            res.data &&
                res.data.orderProducts &&
                res.data.orderProducts.forEach((item, index) => {
                    productsReceivingQuantity[index] =
                        item.quantity - (item.receivedQuantity || 0);
                    receiveBtnsIsLoading[index] = false;
                    allF1OrderReceiveList.push(item);
                });

            this.setState({
                productsReceivingQuantity,
                receiveBtnsIsLoading,
                f1OrderReceiveList: allF1OrderReceiveList,
                f1OrderDetailPageLoad: false,
            });
        });
    };

    inputValid = (value, index) => {
        let {productsReceivingQuantity} = this.state;

        productsReceivingQuantity[index] = value;

        this.setState({productsReceivingQuantity});
    };

    getBatchReceiveOrderArry = () => {
        let productQuantity = this.state.productQuantity;
        let allReceiveOrderArry = this.state.f1OrderReceiveList;

        let receiveOrderArry = allReceiveOrderArry.filter(
            (item) => item.checked,
        );
        let currentAllOrderArry = productQuantity.filter((item) =>
            receiveOrderArry.some((ele) => ele.id === item.orderProductId),
        );

        return currentAllOrderArry;
    };

    shipConfirmationHandle = () => {
        if (this.state.isAllReceive) {
            let allProductQuantity = this.getBatchReceiveOrderArry();
            this.props
                .productsReceive({
                    orderId: this.props.match.params.id,
                    productQuantity: allProductQuantity,
                })
                .then((res) => {
                    this.props.openNotification(
                        T('notification_all_goods_received_successfully'),
                        'success',
                    );
                    this.props.history.replace('/F1OrderList');
                    this.setState({
                        receiveAllBtnIsLoading: false,
                        receiveExitOpened: false,
                    });
                })
                .catch((res) => {
                    this.setState({receiveAllBtnIsLoading: false});
                });
        } else {
            const {productsReceivingQuantity, receiveBtnsIsLoading} =
                this.state;

            receiveBtnsIsLoading[this.state.currentIndex] = true;

            this.setState({receiveBtnsIsLoading});

            this.props
                .productsReceive({
                    orderId: this.props.match.params.id,
                    productQuantity: [
                        {
                            orderProductId: this.state.currentItem.id,
                            quantity:
                                productsReceivingQuantity[
                                    this.state.currentIndex
                                ],
                        },
                    ],
                })
                .then((res) => {
                    this.props.openNotification(
                        T('notification_successful_receipt_of_goods'),
                        'success',
                    );
                    receiveBtnsIsLoading[this.state.currentIndex] = false;
                    this.setState({
                        receiveBtnsIsLoading,
                        receiveExitOpened: false,
                        f1OrderReceiveList: [],
                    });
                    this.getOrderDetails();
                })
                .catch((res) => {
                    receiveBtnsIsLoading[this.state.currentIndex] = false;
                    this.setState({receiveBtnsIsLoading});
                });
        }
    };

    checkQuantity = () => {
        const {productsReceivingQuantity} = this.state;
        let disabled = true;

        productsReceivingQuantity &&
            productsReceivingQuantity.forEach((item) => {
                if (item > 0) disabled = false;
            });

        return disabled;
    };
    goBack = () => {
        this.props.updateF1OrderReceiveSearchList({
            queryKey: {$set: ''},
        });
        this.props.history.goBack();
    };

    openDialog = (name, orderId, productId, orderProductId) => {
        this.setState({
            exitOpened: true,
        });
        this.props.getSkuReplenishmentDetails({
            orderId: orderId,
            productId: productId,
            orderProductId,
        });
    };

    openPackageConditionDialog = (params) => {
        this.setState({
            receiveExitOpened: true,
            f1OrderReceiveData:
                typeof params.resData !== 'undefined' ? params.resData : [],
            isAllReceive: params.isAllReceive,
            currentItem: params.item,
            currentIndex: params.index,
            productQuantity: params.productQuantity,
        });
    };

    closeDialog = (name) => {
        if (this.state[name]) {
            this.setState({
                [name]: false,
                f1OrderReceiveData: [],
            });
        }
    };

    showShippmentDetails = (orderId, productId, orderProductId) => {
        this.openDialog('exitOpened', orderId, productId, orderProductId);
    };

    onChange = (title, value) => {
        this.props.updateF1OrderReceiveSearchList({
            [title]: {$set: value},
        });
    };

    isDisabledBtn = (p) => {
        let isDisabledBtnFlag = true;
        if (p.receivedQuantity > 0) {
            isDisabledBtnFlag = false;
        } else {
            p.componentProducts.length > 0 &&
                p.componentProducts.forEach((cPItem) => {
                    if (cPItem.receivedQuantity > 0) {
                        isDisabledBtnFlag = false;
                    }
                });
        }
        return isDisabledBtnFlag;
    };

    render() {
        const {F1OrderDetails, skuReplenishmentDetail} = this.props;
        const {
            productsReceivingQuantity,
            receiveBtnsIsLoading,
            exitOpened,
            receiveExitOpened,
            f1OrderReceiveData,
            f1OrderReceiveList,
            f1OrderDetailPageLoad,
        } = this.state;
        const tableThContent = [
            'host_fone_receive_amount',
            'host_fone_receive_date',
        ];
        let lang = loadLanguage();

        if (F1OrderDetails.orderProducts) {
            for (let n = 0; n < F1OrderDetails.orderProducts.length; n++) {
                F1OrderDetails.orderProducts[n]['checked'] = true;
            }
        }

        return (
            <div className="f1-order-detail-page-container">
                <div className="container-max-width is-fixed background"></div>
                <div className="container-max-width is-fixed background-cover"></div>

                <Header hasArrowBackIos={true} backEvent={this.goBack}>
                    <p className="header-order-number">
                        {T('host_fone_order_number')}{' '}
                        <span className="numer">{F1OrderDetails.number}</span>
                    </p>
                    <div className="header-search-input">
                        <SearchInput
                            title="queryKey"
                            value={this.props.queryKey}
                            placeholder={T('enter_sku')}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                </Header>
                {f1OrderDetailPageLoad ? (
                    <LoadingIcon className="circle-animation" />
                ) : (
                    <ul className="F1-order-products-list">
                        {f1OrderReceiveList &&
                            f1OrderReceiveList.map((p, index) => (
                                <li key={index}>
                                    <div className="img-box">
                                        <ProductImage
                                            src={
                                                p.product &&
                                                p.product.productPic
                                            }
                                            alt={
                                                p.product &&
                                                p.product.productName
                                            }
                                        />
                                    </div>
                                    {lang !== 'EN' ? (
                                        <div className="details">
                                            <div className="sku-replenishment-detail">
                                                <p className="sku text-ellipsis">
                                                    {p &&
                                                        p.product &&
                                                        p.product.sku}
                                                </p>
                                                <p className="replenishment-detail-area text-ellipsis">
                                                    <Anchor
                                                        className={
                                                            this.isDisabledBtn(
                                                                p,
                                                            )
                                                                ? 'btn btn-disabled'
                                                                : 'btn'
                                                        }
                                                        disabled={this.isDisabledBtn(
                                                            p,
                                                        )}
                                                        onClickOfSingleTap={() =>
                                                            this.showShippmentDetails(
                                                                p.orderId,
                                                                p.productId,
                                                                p.id,
                                                            )
                                                        }>
                                                        {T(
                                                            'fone_order_shippment_details',
                                                        )}
                                                    </Anchor>
                                                </p>
                                            </div>
                                            <div className="quantitys">
                                                <p className="replenishment-quantity text-ellipsis">
                                                    <label>
                                                        {T(
                                                            'host_fone_replenishment_amount_colon',
                                                        )}
                                                    </label>
                                                    {p.quantity}
                                                </p>
                                                <p className="received-quantity text-ellipsis">
                                                    <label>
                                                        {T(
                                                            'host_fone_received_amount',
                                                        )}
                                                    </label>
                                                    {p.receivedQuantity || 0}
                                                </p>
                                            </div>
                                            <p className="sku-specifications">
                                                <label>
                                                    {T(
                                                        'fone_order_specifications_colon',
                                                    )}
                                                </label>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: p.product
                                                            .specifications,
                                                    }}
                                                />
                                            </p>
                                        </div>
                                    ) : (
                                        <div className="details">
                                            <div className="sku-replenishment-detail">
                                                <p className="sku">
                                                    {p &&
                                                        p.product &&
                                                        p.product.sku}
                                                </p>
                                                <p className="en-replenishment-detail-area">
                                                    <Anchor
                                                        className={
                                                            this.isDisabledBtn(
                                                                p,
                                                            )
                                                                ? 'btn btn-disabled'
                                                                : 'btn'
                                                        }
                                                        disabled={this.isDisabledBtn(
                                                            p,
                                                        )}
                                                        onClickOfSingleTap={() =>
                                                            this.showShippmentDetails(
                                                                p.orderId,
                                                                p.productId,
                                                                p.id,
                                                            )
                                                        }>
                                                        {T(
                                                            'fone_order_shippment_details',
                                                        )}
                                                    </Anchor>
                                                </p>
                                            </div>
                                            <div className="quantitys">
                                                <label
                                                    style={{color: '#B1B1B1'}}>
                                                    {T(
                                                        'host_fone_replenishment_amount_colon',
                                                    )}
                                                    &nbsp;
                                                </label>
                                                {p.quantity}
                                            </div>
                                            <div className="quantitys">
                                                <label
                                                    style={{color: '#B1B1B1'}}>
                                                    {T(
                                                        'host_fone_received_amount',
                                                    )}
                                                    &nbsp;
                                                </label>
                                                {p.receivedQuantity || 0}
                                            </div>
                                            <div className="sku-specifications">
                                                <label>
                                                    {T(
                                                        'fone_order_specifications_colon',
                                                    )}
                                                </label>
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: p.product
                                                            .specifications,
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </li>
                            ))}
                    </ul>
                )}
                <PackageDetailsDialog
                    skuReplenishmentDetailData={f1OrderReceiveData}
                    shipConfirmationHandle={this.shipConfirmationHandle}
                    closeDialog={this.closeDialog}
                    opened={receiveExitOpened}
                    isOperateFlag="receive"
                />
                <CommonDialogWrapper
                    skuReplenishmentDetailData={skuReplenishmentDetail}
                    closeDialog={this.closeDialog}
                    exitOpened={exitOpened}
                    tableThContent={tableThContent}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        F1OrderDetails: host.F1OrderDetails,
        skuReplenishmentDetail: host.skuReplenishmentDetail,
        queryKey: host.f1OrderReceiveSearchfields.queryKey,
        updateF1OrderList: host.updateF1OrderList,
    };
};

const mapDispatchToProps = {
    getF1OrderDetails,
    productsReceive,
    openNotification,
    getSkuReplenishmentDetails,
    getAllSkuConditionList,
    updateF1OrderReceiveSearchList,
    updateF1OrderReceiveOrder,
};

export default connect(mapStateToProps, mapDispatchToProps)(F1OrderDetailPage);
